var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 70,
    viewBox: "0 0 88 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21H0.621753C0.0110097 21.8477 0.907897 21.8757 3.31241 22.5325L37.0562 31.7504C40.8912 32.798 47.1089 32.798 50.9438 31.7504L84.6876 22.5325C87.0921 21.8757 87.989 21.8477 87.3783 21H88V49.608V49.7555C88 50.8229 87.0343 51.7429 85.2805 52.5573L50.3508 68.7784C46.8434 70.4072 41.1566 70.4072 37.6491 68.7784L2.71945 52.5573C0.965712 51.7429 -1.508e-06 50.6755 0 49.608V21Z",
    fill: "url(#paint0_linear_7_8357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21H0.621753C0.0110097 21.8477 0.907897 21.8757 3.31241 22.5325L37.0562 31.7504C40.8912 32.798 47.1089 32.798 50.9438 31.7504L84.6876 22.5325C87.0921 21.8757 87.989 21.8477 87.3783 21H88V49.608V49.7555C88 50.8229 87.0343 51.7429 85.2805 52.5573L50.3508 68.7784C46.8434 70.4072 41.1566 70.4072 37.6491 68.7784L2.71945 52.5573C0.965712 51.7429 -1.508e-06 50.6755 0 49.608V21Z",
    fill: "url(#paint1_linear_7_8357)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6363 1.2281C41.1509 -0.409368 46.8491 -0.409368 50.3637 1.2281L85.3641 17.5351C88.8786 19.1726 88.8786 21.8274 85.3641 23.4649L50.3637 39.7719C46.8491 41.4094 41.1509 41.4094 37.6363 39.7719L2.63593 23.4649C-0.878645 21.8274 -0.878644 19.1726 2.63593 17.5351L37.6363 1.2281Z",
    fill: "#219653"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5022 18.3561L53.502 18.3561L53.5012 18.3655C53.4196 19.2739 52.7365 20.1347 51.5998 20.7556L51.5998 20.7556L51.5961 20.7577L41.3886 26.4321C37.3586 28.3528 32.0319 25.1565 35.5054 22.907L35.5318 22.8923L36.1533 22.5468L35.369 22.3197C32.7619 21.565 31.4091 20.4945 30.9325 19.3948C30.4517 18.2856 30.8459 17.1078 31.8618 16.1369C32.8777 15.166 34.4921 14.4243 36.4007 14.1684C38.2928 13.9149 40.5408 14.1297 42.8808 15.1411L43.249 15.3003L43.612 15.145C47.6822 13.4046 53.9011 15.4296 53.5022 18.3561Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.42 25.5306L55.4089 25.5368L54.8751 25.6597L55.1166 25.99C55.483 26.4908 55.3048 27.0944 54.6017 27.4853C53.8986 27.8761 52.8469 27.9563 51.9934 27.7262L51.4307 27.5745L51.1979 27.8778L51.1867 27.884L46.9534 30.2373C46.7609 30.3444 46.4356 30.3391 46.2466 30.2258C46.0576 30.1126 46.0607 29.9248 46.2532 29.8177L50.4865 27.4644L50.4977 27.4582L51.0351 27.3345L50.7884 27.003C50.5288 26.6542 50.5352 26.2622 50.806 25.922L51.0633 25.5988L50.5302 25.4576L50.5192 25.4511L47.8321 23.841L48.5455 23.4444L51.2327 25.0545L51.2436 25.061L51.468 25.3738L52.0374 25.2375C52.6364 25.0941 53.3155 25.1051 53.9096 25.2679L54.4743 25.4226L54.7087 25.1173L54.7198 25.1111L58.9531 22.7577C59.1457 22.6507 59.471 22.656 59.66 22.7692C59.8489 22.8824 59.8459 23.0702 59.6533 23.1773L55.42 25.5306Z",
    fill: "white",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_8357",
    x1: -3.11667,
    y1: 41.4975,
    x2: 88,
    y2: 41.4975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.419404,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595068,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_8357",
    x1: -3.11667,
    y1: 41.4975,
    x2: 88,
    y2: 41.4975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.419404,
    stopColor: "#1B7642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#229855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595068,
    stopColor: "#28A45D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBox);
export default __webpack_public_path__ + "static/media/cloud-box.3ef4f342bb2c38d9f7c235b7a1545f6e.svg";
export { ForwardRef as ReactComponent };